/* ============================================
   BOTANĒ — Cart Drawer JavaScript
   Vanilla JS only. No jQuery.
   Integrates with Feather/Horizon via:
   - cart:update event (dispatched by botane-*.js after add to cart)
   - cart-drawer-component.open() / .close() methods
   ============================================ */

(function () {
  'use strict';

  /* ------------------------------------------
     STATE
     ------------------------------------------ */
  var lastFocusTrigger = null;
  var focusTrapHandler = null;
  var isRendering = false;

  /* ------------------------------------------
     MONEY FORMATTING
     ------------------------------------------ */
  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active
      : 'USD';

    var amount = (cents / 100).toFixed(2);

    var config = {
      'USD': { symbol: '$',   before: true,  decimal: '.' },
      'CAD': { symbol: 'CA$', before: true,  decimal: '.' },
      'AUD': { symbol: 'A$',  before: true,  decimal: '.' },
      'GBP': { symbol: '£',   before: true,  decimal: '.' },
      'EUR': { symbol: '€',   before: false, decimal: ',' },
      'CHF': { symbol: 'CHF', before: true,  decimal: '.' },
      'SEK': { symbol: 'kr',  before: false, decimal: ',' },
      'DKK': { symbol: 'kr',  before: false, decimal: ',' },
      'NOK': { symbol: 'kr',  before: false, decimal: ',' }
    };

    var fmt = config[currency] || { symbol: currency, before: true, decimal: '.' };
    var formatted = amount.replace('.', fmt.decimal);

    return fmt.before
      ? fmt.symbol + formatted
      : formatted + '\u00a0' + fmt.symbol;
  }

  /* ------------------------------------------
     DRAWER OPEN / CLOSE
     ------------------------------------------ */
  function getDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function getDialog() {
    return document.querySelector('.botane-cart-dialog');
  }

  function openCartDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    lastFocusTrigger = document.activeElement;
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else if (typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    }
  }

  function closeCartDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    document.body.classList.remove('botane-cart-open');
    if (typeof drawer.close === 'function') {
      drawer.close();
    } else if (typeof drawer.closeDialog === 'function') {
      drawer.closeDialog();
    }
    restoreFocus();
  }

  function restoreFocus() {
    if (lastFocusTrigger && typeof lastFocusTrigger.focus === 'function') {
      setTimeout(function () { lastFocusTrigger.focus(); }, 50);
    }
  }

  /* ------------------------------------------
     FOCUS TRAP
     ------------------------------------------ */
  function setupFocusTrap(dialog) {
    if (focusTrapHandler) {
      dialog.removeEventListener('keydown', focusTrapHandler);
    }

    focusTrapHandler = function (e) {
      if (e.key !== 'Tab') return;

      var focusable = Array.prototype.slice.call(
        dialog.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (el) {
        return el.offsetParent !== null; /* visible only */
      });

      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    dialog.addEventListener('keydown', focusTrapHandler);
  }

  /* ------------------------------------------
     SHIPPING BAR
     ------------------------------------------ */
  function renderShippingBar(cart) {
  var cartEl = document.querySelector('.botane-cart');

  var baseThreshold = cartEl && cartEl.dataset.shippingThreshold
    ? parseInt(cartEl.dataset.shippingThreshold, 10)
    : 6000;

  var rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
    ? parseFloat(window.Shopify.currency.rate)
    : 1.0;

  var threshold = Math.round(baseThreshold * rate);

  var remaining = Math.max(0, threshold - cart.total_price);
  var percentage = Math.min(100, (cart.total_price / threshold) * 100);

  var fill = document.querySelector('.botane-cart__shipping-fill');
  var text = document.querySelector('.botane-cart__shipping-text');
  var bar = document.getElementById('botane-shipping-bar');

  if (!fill || !text || !bar) return;

  if (cart.item_count === 0) {
    bar.style.display = 'none';
    return;
  }

  bar.style.display = '';
  fill.style.width = percentage + '%';

  if (remaining === 0) {
    text.innerHTML =
      '<span class="botane-cart__shipping-unlocked">Complimentary shipping unlocked.' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-left:4px" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
      '</span>';
  } else {
    text.textContent =
      "You\u2019re " + formatMoney(remaining) + ' away from complimentary shipping.';
  }
}

  /* ------------------------------------------
     SUBTOTAL
     ------------------------------------------ */
  function renderSubtotal(cart) {
    var el = document.querySelector('[data-cart-subtotal]');
    if (el) el.textContent = formatMoney(cart.total_price);
  }

  /* ------------------------------------------
     CART COUNT (header bubble)
     ------------------------------------------ */
  function updateCartCount(count) {
    /* The theme's cart-icon custom element listens to cart:update,
       so the bubble updates automatically. This is a safety fallback. */
    var bubbles = document.querySelectorAll('.cart-bubble__text-count');
    bubbles.forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
  }

  /* ------------------------------------------
     EMPTY / FULL STATE TOGGLE
     ------------------------------------------ */
  function toggleEmptyState(isEmpty) {
    var itemsEl = document.getElementById('botane-cart-items');
    var emptyEl = document.getElementById('botane-cart-empty');
    var shippingBar = document.getElementById('botane-shipping-bar');
    var trustEl = document.getElementById('botane-cart-trust');
    var footerEl = document.getElementById('botane-cart-footer');
    var crossSellEl = document.getElementById('botane-cart-cross-sell');

    if (isEmpty) {
      if (itemsEl) itemsEl.style.display = 'none';
      if (emptyEl) emptyEl.hidden = false;
      if (shippingBar) shippingBar.style.display = 'none';
      if (trustEl) trustEl.hidden = true;
      if (footerEl) footerEl.hidden = true;
      if (crossSellEl) crossSellEl.hidden = true;
    } else {
      if (itemsEl) itemsEl.style.display = '';
      if (emptyEl) emptyEl.hidden = true;
      if (shippingBar) shippingBar.style.display = '';
      if (trustEl) trustEl.hidden = false;
      if (footerEl) footerEl.hidden = false;
    }
  }

  /* ------------------------------------------
     RENDER LINE ITEMS
     ------------------------------------------ */
  function renderLineItems(items) {
    var container = document.getElementById('botane-cart-items');
    if (!container) return;

    if (items.length === 0) {
      container.innerHTML = '';
      return;
    }

    var html = items.map(function (item) {
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="botane-cart__item-variant">' + escapeHtml(item.variant_title) + '</span>'
        : '';

      var imageUrl = item.image || '';
      var imageHtml = imageUrl
        ? '<img src="' + escapeAttr(imageUrl) + '" alt="' + escapeAttr(item.title) + '" width="60" height="75" loading="lazy" class="botane-cart__item-image">'
        : '<div class="botane-cart__item-image" style="background:var(--botane-border-light)"></div>';

      return (
        '<div class="botane-cart__item" role="listitem" data-line-key="' + escapeAttr(item.key) + '">' +
          '<a href="' + escapeAttr(item.url) + '" class="botane-cart__item-image-link" tabindex="-1" aria-hidden="true">' +
            imageHtml +
          '</a>' +
          '<div class="botane-cart__item-info">' +
            '<a href="' + escapeAttr(item.url) + '" class="botane-cart__item-title">' + escapeHtml(item.product_title) + '</a>' +
            variantTitle +
            '<span class="botane-cart__item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '<div class="botane-cart__item-controls">' +
              '<div class="botane-cart__quantity" role="group" aria-label="Quantity for ' + escapeAttr(item.product_title) + '">' +
                '<button class="botane-cart__qty-btn" data-action="decrease" aria-label="Decrease quantity of ' + escapeAttr(item.product_title) + '">\u2212</button>' +
                '<span class="botane-cart__qty-value" aria-label="Quantity: ' + item.quantity + '">' + item.quantity + '</span>' +
                '<button class="botane-cart__qty-btn" data-action="increase" aria-label="Increase quantity of ' + escapeAttr(item.product_title) + '">+</button>' +
              '</div>' +
              '<button class="botane-cart__item-remove" data-action="remove" aria-label="Remove ' + escapeAttr(item.product_title) + ' from cart">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    container.innerHTML = html;
  }

  /* ------------------------------------------
     CROSS-SELL
     ------------------------------------------ */
  function updateCrossSell(cartItems) {
    var dataEl = document.getElementById('botane-ritual-products');
    var container = document.getElementById('botane-cart-cross-sell');
    var grid = document.getElementById('botane-cross-sell-grid');

    if (!dataEl || !container || !grid) return;

    var ritualData;
    try {
      ritualData = JSON.parse(dataEl.textContent);
    } catch (e) {
      container.hidden = true;
      return;
    }

    if (!ritualData || ritualData.length === 0) {
      container.hidden = true;
      return;
    }

    var cartHandles = cartItems.map(function (item) { return item.handle; });
    var missing = ritualData.filter(function (p) {
      return cartHandles.indexOf(p.handle) === -1;
    });

    /* Logic: 0 cart items → hide; all in cart → hide */
    if (missing.length === 0 || cartItems.length === 0) {
      container.hidden = true;
      return;
    }

    /* 1 in cart → show 2 recommendations; 2 in cart → show 1 */
    var showCount = Math.max(1, Math.min(missing.length, ritualData.length - cartHandles.filter(function (h) {
      return ritualData.some(function (p) { return p.handle === h; });
    }).length));
    var toShow = missing.slice(0, showCount);

    container.hidden = false;

    grid.innerHTML = toShow.map(function (product) {
      var imageHtml = product.image
        ? '<img src="' + escapeAttr(product.image) + '" alt="' + escapeAttr(product.title) + '" width="60" height="75" loading="lazy">'
        : '<div style="width:60px;height:75px;background:var(--botane-border-light)"></div>';

      var benefit = product.benefit
        ? '<span class="botane-cart__cross-sell-benefit">' + escapeHtml(product.benefit) + '</span>'
        : '';

      return (
        '<div class="botane-cart__cross-sell-card">' +
          imageHtml +
          '<div class="botane-cart__cross-sell-info">' +
            '<span class="botane-cart__cross-sell-name">' + escapeHtml(product.title) + '</span>' +
            benefit +
            '<span class="botane-cart__cross-sell-price">' + escapeHtml(product.price_formatted) + '</span>' +
          '</div>' +
          '<button class="botane-cart__cross-sell-add" data-variant-id="' + escapeAttr(String(product.variant_id)) + '" aria-label="Add ' + escapeAttr(product.title) + ' to cart">ADD</button>' +
        '</div>'
      );
    }).join('');
  }

  /* ------------------------------------------
     FETCH & RENDER
     ------------------------------------------ */
  function fetchAndRenderCart() {
    if (isRendering) return;
    isRendering = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderLineItems(cart.items);
        renderSubtotal(cart);
        renderShippingBar(cart);
        updateCrossSell(cart.items);
        updateCartCount(cart.item_count);
        toggleEmptyState(cart.item_count === 0);

        /* Focus close button on open */
        var dialog = getDialog();
        if (dialog && dialog.hasAttribute('open')) {
          setupFocusTrap(dialog);
          var closeBtn = dialog.querySelector('.botane-cart__close');
          if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
        }
      })
      .catch(function (err) {
        console.error('[BOTANE] Cart fetch error:', err);
      })
      .finally(function () {
        isRendering = false;
      });
  }

  /* ------------------------------------------
     QUANTITY CHANGE & REMOVE
     ------------------------------------------ */
  function changeQuantity(lineKey, newQuantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQuantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderLineItems(cart.items);
        renderSubtotal(cart);
        renderShippingBar(cart);
        updateCrossSell(cart.items);
        updateCartCount(cart.item_count);
        toggleEmptyState(cart.item_count === 0);

        /* Dispatch cart:update so theme cart icon bubble also updates */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: 'botane-cart-drawer',
            data: { source: 'cart-drawer', itemCount: cart.item_count }
          }
        }));
      })
      .catch(function (err) {
        console.error('[BOTANE] Quantity change error:', err);
      });
  }

  /* ------------------------------------------
     CROSS-SELL ADD TO CART
     ------------------------------------------ */
  function crossSellAdd(variantId, btn) {
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          btn.textContent = 'Error';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
          return;
        }
        btn.textContent = 'ADDED \u2713';
        fetchAndRenderCart();

        /* Dispatch cart:update for theme cart icon */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: 'botane-cart-cross-sell',
            data: { source: 'cart-drawer', itemCount: 1 }
          }
        }));

        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = 'ERROR';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
  }

  /* ------------------------------------------
     EVENT DELEGATION (click handler)
     ------------------------------------------ */
  function handleDocumentClick(e) {
    /* Close button */
    if (e.target.closest('.botane-cart__close')) {
      closeCartDrawer();
      return;
    }

    /* Continue Shopping */
    if (e.target.closest('.botane-cart__continue')) {
      closeCartDrawer();
      return;
    }

    /* Quantity buttons */
    var qtyBtn = e.target.closest('.botane-cart__qty-btn');
    if (qtyBtn) {
      var item = qtyBtn.closest('.botane-cart__item');
      if (!item) return;
      var key = item.dataset.lineKey;
      var action = qtyBtn.dataset.action;
      var qtyEl = item.querySelector('.botane-cart__qty-value');
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (action === 'increase') changeQuantity(key, currentQty + 1);
      if (action === 'decrease') changeQuantity(key, Math.max(0, currentQty - 1));
      return;
    }

    /* Remove */
    var removeBtn = e.target.closest('.botane-cart__item-remove');
    if (removeBtn) {
      var item = removeBtn.closest('.botane-cart__item');
      if (!item) return;
      var key = item.dataset.lineKey;
      if (key) changeQuantity(key, 0);
      return;
    }

    /* Cross-sell ADD */
    var addBtn = e.target.closest('.botane-cart__cross-sell-add');
    if (addBtn && !addBtn.disabled) {
      crossSellAdd(addBtn.dataset.variantId, addBtn);
      return;
    }
  }

  /* ------------------------------------------
     BACKDROP CLICK TO CLOSE
     ------------------------------------------ */
  function handleDialogClick(e) {
    /* Clicking the <dialog> element itself (outside .botane-cart) closes it */
    if (e.target === e.currentTarget) {
      closeCartDrawer();
    }
  }

  /* ------------------------------------------
     DIALOG OPEN OBSERVER
     Watches for the `open` attribute on the <dialog> element.
     When it appears: fetch cart, setup focus trap, lock scroll.
     When it disappears: restore focus, unlock scroll.
     ------------------------------------------ */
  function observeDialog(dialog) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== 'open') return;

        if (dialog.hasAttribute('open')) {
          /* Drawer just opened */
          document.body.classList.add('botane-cart-open');
          fetchAndRenderCart();
        } else {
          /* Drawer just closed */
          document.body.classList.remove('botane-cart-open');
          restoreFocus();
        }
      });
    });

    observer.observe(dialog, { attributes: true });
  }

  /* ------------------------------------------
     TRACK TRIGGER ELEMENT
     ------------------------------------------ */
  function trackTrigger() {
    /* Cart icon button */
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        lastFocusTrigger = trigger;
      });
    }

    /* cart:update event fires when add-to-cart succeeds */
    document.addEventListener('cart:update', function () {
      if (!lastFocusTrigger) {
        lastFocusTrigger = document.activeElement;
      }
    });
  }

  /* ------------------------------------------
     ESCAPE KEY
     The HTML5 <dialog> element natively fires 'cancel' on ESC,
     which calls close(). We hook into it to restore focus.
     ------------------------------------------ */
  function setupEscHandler(dialog) {
    dialog.addEventListener('cancel', function () {
      document.body.classList.remove('botane-cart-open');
      restoreFocus();
    });
  }

  /* ------------------------------------------
     ESCAPE HTML (XSS prevention)
     ------------------------------------------ */
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ------------------------------------------
     INIT
     ------------------------------------------ */
  function init() {
    var dialog = getDialog();
    if (!dialog) return;

    observeDialog(dialog);
    setupEscHandler(dialog);
    trackTrigger();

    /* Backdrop click */
    dialog.addEventListener('click', handleDialogClick);

    /* Event delegation for all cart interactions */
    document.addEventListener('click', handleDocumentClick);
  }

  /* Run after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();